import dayjs from 'dayjs';
import { memo } from 'react';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import {
	Box, Switch,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import strings from '../Globalization';
import consts from '../consts';
import Model from '../models/model';
import { useGridBase } from '../components/grid/GridBaseContext';


const CustomSwitch = styled(Switch)(({ theme }) => ({
	padding: 8,
	'& .MuiSwitch-track': {
		borderRadius: 22 / 2,
		'&:before, &:after': {
			content: '""',
			position: 'absolute',
			top: '50%',
			transform: 'translateY(-50%)',
			width: 16,
			height: 16
		},
		'&:before': {
			backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
				theme.palette.getContrastText(theme.palette.primary.main)
			)}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
			left: 12
		},
		'&:after': {
			backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
				theme.palette.getContrastText(theme.palette.primary.main)
			)}" d="M19,13H5V11H19V13Z" /></svg>')`,
			right: 12
		}
	},
	'& .MuiSwitch-thumb': {
		boxShadow: 'none',
		width: 16,
		height: 16,
		margin: 2
	}
}));

const CustomSwitchInput = memo(() => {
	const { patch, getState } = useGridBase();
	const { standaloneFilters } = getState()

	const handleChange = async (e) => {
		patch(prev => ({ standaloneFilters: { ...prev.standaloneFilters, hideHeartbeat: e.target.checked } }))
	}

	return (< Box container="true">
		<CustomSwitch
			headerfilter="true"
			standaloneheaderfilter="true"
			defaultChecked={false}
			checked={standaloneFilters?.hideHeartbeat}
			onChange={handleChange}
			name="hideHeartbeat"
			color="success"
		/>
	</Box >)
});

const CustomCheckBox = memo(() => {
	return (
		<FormGroup>
			<FormControlLabel control={<CustomSwitchInput />} label={strings.hideHeartbeat} />
		</FormGroup>
	)
})

const handleClearStandaloneFilters = ({ initialValues = {}, formik }) => {
	const initialStandaloneFilterValues = { startDate: initialValues.startDate, endDate: initialValues.endDate, hideHeartbeat: formik.values.hideHeartbeat };
	formik.resetForm({ values: initialStandaloneFilterValues });
	formik.handleSubmit();
}


const model = new Model({
	name: 'Logs',
	idProperty: '_id',
	disableDelete: true,
	disableAdd: true,
	disableExport: false,
	formTitleField: 'startDate',
	showGridRefreshBtn: true,
	title: 'Logs',
	defaultSort: [
		{
			field: 'createdAt',
			sort: 'desc'
		}
	],
	isJson: true,
	gridToolbarCustomActions: [
		{
			Component: CustomCheckBox
		}
	],
	onClearHeaderFilter: handleClearStandaloneFilters,
	columns: [
		{ header: 'UniqueId', field: '_id', keyColumn: true, hidden: true, width: 120 },
		{ field: 'client', header: 'ClientName', width: 150, pdfExportWidth: 50 },
		{ field: 'data', header: 'Payload', width: 700, pdfExportWidth: 200, exportCharLimit: 500 },
		{ field: 'topic', header: 'Topic', width: 400 },
		{ field: 'qos', header: 'QoS', width: 100, pdfExportWidth: 50 },
		{
			field: 'createdAt',
			header: 'CreatedOn',
			width: 220,
			type: 'dateTime',
			isLocal: true,
			showSecond: true
		},
		{
			field: 'startDate',
			header: 'StartDate',
			hide: true,
			headerFilter: true,
			standaloneHeaderFilter: true,
			type: 'dateTime',
			defaultValue: dayjs().subtract(5, 'day').startOf('day'),
			maxDate: ({ formik }) => (formik.values.endDate ? dayjs(formik.values.endDate) : undefined),
			maxTime: ({ formik }) => (formik.values.endDate ? dayjs(formik.values.endDate) : undefined),
			showSecond: true,
			submitFormat: consts.MomentFormat.DateTime24Hour
		},
		{
			field: 'endDate',
			header: 'EndDate',
			hide: true,
			headerFilter: true,
			standaloneHeaderFilter: true,
			minDate: ({ formik }) => (formik.values.startDate ? dayjs(formik.values.startDate) : undefined),
			type: 'dateTime',
			defaultValue: dayjs().endOf('day'),
			minTime: ({ formik }) => (formik.values.startDate ? dayjs(formik.values.startDate) : undefined),
			showSecond: true,
			submitFormat: consts.MomentFormat.DateTime24Hour

		},
		{
			field: 'hideHeartbeat',
			hide: true,
			headerFilter: true,
			standaloneHeaderFilter: true,
			hideStandalonHeaderFilters: true
		}
	],
	headerFilterProps: {
		className: 'HeaderFilterForm'
	},
	limit: 1000,
});

export default model.createFormBase();
